



























































































import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import Cookies from 'js-cookie';
import storage from 'baimahu/storage';
const getUrl = require('bmh/url-with-param');
const { VUE_APP_FCREST: FCREST, VUE_APP_API } = process.env;

const API = {
  clerk: `${FCREST}/promotion/shang/activity/credit/clerkrank`,
  query_first_clerk: `${FCREST}/setting/shang/clerk/search`, // 查询一级分销员
  setting: `${VUE_APP_API}/qy/merchant/account/config`,
};

interface PaginationData {
  current: number;
  data: any[];
  last: number;
  size: number;
  total: number;
}

function getPaginationData(remote?: PaginationData) {
  remote = (remote || {}) as PaginationData;
  return {
    current: remote.current || 1,
    data: remote.data || [],
    last: remote.last || 1,
    total: remote.total || 0,
    size: remote.size || 1,
  };
}
@Component
export default class ActivityIntegrationRank extends Vue {
  activity_id: number | string = '';
  ambassador_clerk_data: any = getPaginationData();
  ambassador_moment: Moment[] = [];
  first_clerk_list: any = [];
  first_title_name: string = '';
  is_loading: boolean = false;
  partner_clerk_data: any = getPaginationData();
  parent_clerk_id: number | string = '请输入后选择';
  partner_moment: Moment[] = [];
  second_title_name: string = '';
  // 获取分销员信息

  async getSettingInfo() {
    this.is_loading = true;
    const res = await this.$axios.get(API.setting);
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.first_title_name = res.data.data.role_name;
    this.second_title_name = res.data.data.role_name_two;
  }

  async queryClerk(
    activity_id: number | string,
    level: number,
    start_time: number | string,
    end_time: number | string,
    parent_clerk_id: number = 0,
    page: number = 1,
  ) {
    this.is_loading = true;
    const res = await this.$axios.get(
      getUrl(API.clerk, {
        activity_id,
        start_time,
        end_time,
        level,
        parent_clerk_id,
        page,
      }),
    );
    this.is_loading = false;
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    if (level === 1) {
      this.partner_clerk_data = getPaginationData(res.data.data);
    } else {
      this.ambassador_clerk_data = getPaginationData(res.data.data);
    }
  }

  // 归属一级搜索
  async queryFirstClerk(name?: string) {
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const res = await this.$axios.get(
      `${
        API.query_first_clerk
      }?merchant_id=${merchant_id}&level=${1}&name=${name}`,
    );
    this.first_clerk_list = [];
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.first_clerk_list = res.data.data;
  }

  paginationOptions(data: PaginationData) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size || 1,
      current: data.current || 1,
    };
  }

  handleChangePagingFirst(pagination: any, table_filters: any, sorter: any) {
    // level为1时代表合伙人，2代表大使
    const time_bucket = this.getTimeBucket(1);
    const next_page = pagination.current;
    this.queryClerk(
      this.activity_id,
      1,
      time_bucket.start_time,
      time_bucket.end_time,
      0,
      next_page,
    );
  }

  handleChangePagingSecond(pagination: any, table_filters: any, sorter: any) {
    // level为1时代表合伙人，2代表大使
    const time_bucket = this.getTimeBucket(2);
    const next_page = pagination.current;
    this.queryClerk(
      this.activity_id,
      2,
      time_bucket.start_time,
      time_bucket.end_time,
      0,
      next_page,
    );
  }

  // 搜索分销员
  async searchClerk(level: number) {
    // level为1时代表合伙人，2代表大使
    const time_bucket = this.getTimeBucket(level);
    if (level === 2) {
      await this.queryClerk(
        this.activity_id,
        level,
        time_bucket.start_time,
        time_bucket.end_time,
        +this.parent_clerk_id,
      );
      return;
    }
    await this.queryClerk(
      this.activity_id,
      level,
      time_bucket.start_time,
      time_bucket.end_time,
    );
  }

  // 获取时间段
  getTimeBucket(level: number) {
    // level为1时代表合伙人，2代表大使

    let start_time;
    let end_time;
    if (level === 1) {
      start_time =
        this.partner_moment.length > 0
          ? moment(this.partner_moment[0].format('YYYY-MM-DD 00:00:00')).format(
              'X',
            )
          : '';
      end_time =
        this.partner_moment.length > 0
          ? moment(this.partner_moment[1].format('YYYY-MM-DD 23:59:59')).format(
              'X',
            )
          : '';
    } else {
      start_time =
        this.ambassador_moment.length > 0
          ? moment(
              this.ambassador_moment[0].format('YYYY-MM-DD 00:00:00'),
            ).format('X')
          : '';
      end_time =
        this.ambassador_moment.length > 0
          ? moment(
              this.ambassador_moment[0].format('YYYY-MM-DD 23:59:59'),
            ).format('X')
          : '';
    }
    return { start_time, end_time };
  }

  async created() {
    this.activity_id = this.$route.query.activity_id as string;
    await this.queryClerk(this.activity_id, 1, '', '');
    await this.queryClerk(this.activity_id, 2, '', '');
    this.queryFirstClerk();
    this.getSettingInfo();
  }
}
